import { createClient, type SupabaseClient } from '@supabase/supabase-js';

/**
 * Supabase client for auth (and later: cloud project storage / Pro).
 *
 * Keys come from Vite env vars — set them in a local `.env` (see .env.example)
 * and in the Cloudflare Pages project settings:
 *   VITE_SUPABASE_URL       = https://<project>.supabase.co
 *   VITE_SUPABASE_ANON_KEY  = <the public anon key>
 *
 * The anon key is safe to ship in the client bundle — it only grants what your
 * Supabase Row-Level-Security policies allow. Never put the service-role key here.
 */
const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

/** True once both env vars are present, so the UI can show a clear setup
 *  notice instead of crashing when they're missing. */
export const isSupabaseConfigured = Boolean(url && anonKey);

export const supabase: SupabaseClient | null = isSupabaseConfigured
  ? createClient(url as string, anonKey as string, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
    })
  : null;
